module.exports = __webpack_public_path__ + "img/datacenter3.2baa2e09.png";